import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { CategoryOutlined } from '@mui/icons-material';
import { usePMDetailsEditor } from '../../../../hooks/usePMDetailsEditor';
import { useGetPMCategoriesQuery } from '../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const PMCategoryEditor: React.FC<Props> = ({ mode }) => {
  const { pmCategory, updatePMField } = usePMDetailsEditor(mode);
  const { data: pmCategories = [], isLoading } = useGetPMCategoriesQuery();
  const labelId = `${mode}-pm-category-label`;

  const handleChange = (value: string) => {
    updatePMField({ category: value });
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth required>
        <InputLabel id={labelId}>PM Category</InputLabel>
        <Select
          labelId={labelId}
          value={pmCategory || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="PM Category"
          disabled={isLoading}
          startAdornment={
            <InputAdornment position="start">
              <CategoryOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {pmCategories.map((cat) => (
            <MenuItem key={cat.value} value={cat.value}>
              {cat.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PMCategoryEditor;
